import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ConsignmentStatusType from "../../enums/ConsignmentStatusType";
import dayjs from "dayjs";
const ConsignmentStatusText = ({ consignment }) => {
    const cav = "assignedVehicles" in consignment && consignment.assignedVehicles && consignment.assignedVehicles.length && consignment.assignedVehicles[0];
    if (!cav) {
        return (_jsx("span", { children: ConsignmentStatusType.renderTagForConsignment(consignment) }));
    }
    const statusEnum = ConsignmentStatusType.valueOf(consignment.status);
    if (statusEnum === ConsignmentStatusType.ASSIGNED) {
        const assignedAt = dayjs(cav.assignedAt);
        return (_jsxs("span", { children: [ConsignmentStatusType.renderTagForConsignment(consignment), _jsx("br", {}), assignedAt.format("DD/MM/YYYY HH:mm")] }));
    }
    else if (statusEnum === ConsignmentStatusType.STARTED) {
        if (consignment.deliveryArrivedAt) {
            const arrivedAt = dayjs(consignment.deliveryArrivedAt);
            return (_jsxs("span", { children: [ConsignmentStatusType.renderTagForConsignment(consignment), _jsx("br", {}), arrivedAt.format("DD/MM/YYYY HH:mm")] }));
        }
        else {
            const startedAt = dayjs(cav.startedAt);
            const eta = startedAt.clone();
            consignment.deliveryCalcTravelSeconds && eta.add(consignment.deliveryCalcTravelSeconds, 's');
            return (_jsxs("span", { children: [ConsignmentStatusType.renderTagForConsignment(consignment), _jsx("br", {}), startedAt.format("DD/MM/YYYY HH:mm"), _jsx("br", {}), "Eta: ", eta.format("HH:mm")] }));
        }
    }
    else if (statusEnum === ConsignmentStatusType.COMPLETED) {
        const completedAt = dayjs(consignment.completedAt);
        return (_jsxs("span", { children: [ConsignmentStatusType.renderTagForConsignment(consignment), _jsx("br", {}), completedAt.format("DD/MM/YYYY HH:mm")] }));
    }
    else {
        return statusEnum?.renderTag();
    }
};
export default ConsignmentStatusText;
